export const pdf = '.pdf';
export const jpg = '.jpg';
export const jpeg = '.jpeg';
export const png = '.png';
export const allowedUploadExtensions: string[] = [jpg, jpeg, png, pdf];
